var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = {}, _obj[_vm.$c('layout')] = true, _obj[_vm.$c(("layout-" + (_vm.direction || _vm.hasSidebar() ? 'row' : 'column')))] = true, _obj[_vm.$c('layout-has-sidebar')] = _vm.hasSidebar(), _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }